
import React from 'react';
import { AspectRatio } from './ui/aspect-ratio';
import { Card, CardContent } from './ui/card';

const TraineeAccomplishments = () => {
  return (
    <section id="accomplishments" className="py-8 sm:py-12 md:py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-6 sm:mb-8 md:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-4">Trainee Accomplishments</h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Our trainees achieve remarkable results through dedication and expert coaching.
            Take a look at some of our recent success stories.
          </p>
        </div>

        {/* Credentials Section */}
        <div className="mb-8 sm:mb-12">
          <div className="flex justify-center">
            <img 
              src="/lovable-uploads/297e4f0e-cbfc-4a7f-b172-8daf080b3b21.png" 
              alt="Jr. NBA Logo" 
              className="w-48 h-24 object-contain animate-fade-up"
            />
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-8">
          <Card className="overflow-hidden transition-all hover:shadow-lg">
            <CardContent className="p-3 sm:p-4 md:p-6">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <AspectRatio ratio={1}>
                  <img 
                    src="/lovable-uploads/6146a55b-7d0a-46b6-9742-7d695cc99535.png" 
                    alt="Trainee with Greensboro Swarm Jersey" 
                    className="object-cover w-full h-full rounded-md"
                  />
                </AspectRatio>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-1 sm:mb-2">Professional Development</h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-600">
                Our trainee proudly representing the Greensboro Swarm organization.
              </p>
            </CardContent>
          </Card>
          
          <Card className="overflow-hidden transition-all hover:shadow-lg">
            <CardContent className="p-3 sm:p-4 md:p-6">
              <div className="mb-2 sm:mb-3 md:mb-4">
                <AspectRatio ratio={1}>
                  <img 
                    src="/lovable-uploads/58f73fcc-1b53-4ef1-94f0-5ad9765f0cf5.png" 
                    alt="US Junior Nationals Top Performer Jurnee Darling" 
                    className="object-cover w-full h-full rounded-md"
                  />
                </AspectRatio>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-1 sm:mb-2">US Junior Nationals Top Performer</h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-600">
                Jurnee excelled at the US Junior Nationals tournament, earning recognition as a Top Performer.
              </p>
            </CardContent>
          </Card>
          
          <Card className="overflow-hidden transition-all hover:shadow-lg">
            <CardContent className="p-3 sm:p-4 md:p-6 flex flex-col items-center justify-center h-full">
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 md:mb-4">Want to Join Our Success Stories?</h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-600 text-center mb-3 sm:mb-4">
                Train with us and reach your full potential. Sign up for our training programs today!
              </p>
              <a 
                href="#registration" 
                className="bg-primary text-white px-3 sm:px-4 md:px-6 py-1.5 sm:py-2 md:py-3 rounded-md hover:bg-primary/90 transition-colors text-xs sm:text-sm md:text-base"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('registration')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Register Now
              </a>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TraineeAccomplishments;
